import * as React from 'react'

import Svg, { Circle, ClipPath, Defs, G, Path } from 'react-native-svg'

const AccountBlocked = (props) => (
  <Svg
    width={98}
    height={99}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M80.569 10.652 46.29.105C46.027 0 45.764 0 45.5 0s-.527 0-.791.105L10.43 10.652c-1.107.37-1.845 1.371-1.845 2.532v26.718c0 38.444 35.754 49.887 36.123 49.992.264.053.527.106.791.106s.527-.053.791-.106c.369-.105 36.123-11.549 36.123-49.992V13.184c0-1.16-.738-2.163-1.846-2.532Z"
      fill="#8691A8"
    />
    <Path
      d="M82.414 13.184v26.718c0 38.444-35.754 49.887-36.123 49.992-.264.053-.527.106-.791.106V0c.264 0 .527 0 .791.105L80.57 10.652c1.107.37 1.845 1.371 1.845 2.532Z"
      fill="#596379"
    />
    <Path
      d="M60.234 62.554a2.64 2.64 0 0 1-1.55-2.403V56.99c0-2.198-7.087-3.903-13.184-3.903-6.097 0-13.184 1.705-13.184 3.904v3.161a2.64 2.64 0 0 1-1.55 2.403c-.942.427-2.05.26-2.83-.422-5.595-4.929-8.803-12.069-8.803-19.593 0-14.538 11.829-26.367 26.367-26.367s26.367 11.83 26.367 26.367c0 7.524-3.208 14.664-8.804 19.593a2.642 2.642 0 0 1-2.83.422Z"
      fill="#596379"
    />
    <Path
      d="M58.684 56.99v3.161a2.64 2.64 0 0 0 1.55 2.403 2.643 2.643 0 0 0 2.83-.422c5.595-4.929 8.803-12.069 8.803-19.593 0-14.538-11.829-26.367-26.367-26.367v36.914c6.097 0 13.184 1.705 13.184 3.904Z"
      fill="#2F3440"
    />
    <Path
      d="M45.5 47.813c-5.817 0-10.547-4.73-10.547-10.547s4.73-10.547 10.547-10.547 10.547 4.73 10.547 10.547c0 5.816-4.73 10.547-10.547 10.547Z"
      fill="#FFF5F5"
    />
    <Path
      d="M45.5 68.906c-6.569 0-12.818-2.397-17.597-6.751a2.636 2.636 0 0 1-.86-1.95V56.99c0-8.92 16.567-9.178 18.457-9.178 1.89 0 18.457.258 18.457 9.178v3.216c0 .741-.312 1.45-.86 1.949-4.779 4.354-11.028 6.751-17.597 6.751Z"
      fill="#FFF5F5"
    />
    <Path
      d="M63.097 62.155c.548-.5.86-1.208.86-1.95V56.99c0-8.92-16.567-9.178-18.457-9.178v21.094c6.569 0 12.818-2.397 17.597-6.751ZM56.047 37.266c0-5.817-4.73-10.547-10.547-10.547v21.093c5.817 0 10.547-4.73 10.547-10.546Z"
      fill="#E3E7EA"
    />
    <Circle cx={71} cy={72.5} r={26.5} fill="#fff" />
    <G clipPath="url(#a)">
      <Path
        d="M85.642 58.858A19.87 19.87 0 0 0 71.5 53a19.87 19.87 0 0 0-14.142 5.858A19.869 19.869 0 0 0 51.5 73a19.87 19.87 0 0 0 5.858 14.142A19.87 19.87 0 0 0 71.5 93c5.342 0 10.365-2.08 14.142-5.858A19.869 19.869 0 0 0 91.5 73a19.87 19.87 0 0 0-5.858-14.142Zm-20.087 2.99a12.566 12.566 0 0 1 5.945-1.483c6.967 0 12.635 5.668 12.635 12.635 0 2.094-.509 4.124-1.483 5.945L65.555 61.848Zm11.89 22.304a12.567 12.567 0 0 1-5.945 1.483c-6.967 0-12.635-5.668-12.635-12.635 0-2.094.51-4.124 1.483-5.945l17.097 17.097Z"
        fill="#FF5B5B"
      />
      <Path
        d="M85.642 58.858A19.87 19.87 0 0 0 71.5 53v7.364c6.967 0 12.635 5.669 12.635 12.636 0 2.094-.509 4.124-1.483 5.945L71.5 67.793v10.415l5.945 5.944a12.567 12.567 0 0 1-5.945 1.483V93c5.342 0 10.365-2.08 14.142-5.858A19.869 19.869 0 0 0 91.5 73a19.87 19.87 0 0 0-5.858-14.142Z"
        fill="#FF0059"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(51.5 53)" d="M0 0h40v40H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AccountBlocked
